import AbstractCalls from "./AbstractCalls";

class TeamCalls extends AbstractCalls {
  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  create(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/create");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  update(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/update");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} body
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Public team start list. One row per team already on the start list.
   * @param {Object} body
   * @param {string} body.raceId
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  getStartList(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/getStartList");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * @param {Object} body
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/list");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * @param {Object} body
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  listLogs(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/listLogs");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  resolveMember(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/resolveMember");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  setMemberData(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/setMemberData");
    return AbstractCalls.put(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  addVoucher(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/addVoucher");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  submit(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/submit");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  submitMember(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/submitMember");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Captain-only wipe of a draft team and the captain registration.
   * @param {Object} dtoIn
   * @param {Object} [options]
   * @returns {Promise<Object>}
   */
  delete(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "team/delete");
    return AbstractCalls.delete(cmdUri, dtoIn, options);
  }
}

export default new TeamCalls();
